module.exports = __webpack_public_path__ + "615f1069c66300ba9483acf7f045fffb.svg";